import { useTranslation } from '../../utils/convergence'
import { PaymentMethodType } from '../../model'
import { LogEvent } from '../../model/monitoring'
import {
  selectPurchaseMethod,
  setStartConfirmTime,
  useAppDispatch,
  useApplePay,
  useIsReadyToConfirm,
  useIsUpdatePreferredPaymentDay,
  useIsTrustedCheckout,
  useOAuthAuthorizationFlow,
  useSelectedPaymentMethod,
} from '../../state'
import { useConfirmCheckoutFinaliser } from '../../state/checkout/useConfirmCheckoutFinaliser'

export const useOnConfirmButtonClick = (): (() => Promise<void>) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const ready = useIsReadyToConfirm()
  const selectedPaymentMethod = useSelectedPaymentMethod()
  const applePayHelper = useApplePay()

  const isTrusted = useIsTrustedCheckout()
  const { oAuthAuthorization } = useOAuthAuthorizationFlow()

  const shouldUpdatePreferredPaymentDay = useIsUpdatePreferredPaymentDay()
  const finaliseCheckout = useConfirmCheckoutFinaliser({
    t,
    isTrusted,
    oAuthAuthorization,
    shouldUpdatePreferredPaymentDay,
  })

  return async () => {
    if (!ready || selectedPaymentMethod === undefined) {
      return
    }

    dispatch(setStartConfirmTime(performance.now()))
    await dispatch(selectPurchaseMethod(selectedPaymentMethod))

    if (selectedPaymentMethod?.type === PaymentMethodType.APPLE_PAY) {
      const logEvent: LogEvent = () => {}
      applePayHelper.initialise(t, logEvent)
      try {
        await applePayHelper.startSession()
      } catch (e) {
        return
      }
    }

    await finaliseCheckout()
  }
}
